module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page rowBackgroundHomepage"
  }, [_c('div', {
    staticClass: "showSmallScreenOnly"
  }, [_c('f7-fab', {
    staticClass: "leftfav bottomButton floatingButtonToolbarBlank",
    attrs: {
      "href": "/attachments/import/",
      "disabled": _vm.$engine.rights.rightIs('attachment_import', false)
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "bullet_list"
    }
  })], 1), _vm._v(" "), _c('f7-fab', {
    staticClass: "leftfav3 bottomButton floatingButtonToolbarBlank",
    attrs: {
      "href": "/attachments/createInvoice/",
      "disabled": _vm.$engine.rights.rightIs('attachment_ajouter_facture', false)
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "add"
    }
  })], 1), _vm._v(" "), _c('f7-fab', {
    staticClass: "leftfav3 bottomButton floatingButtonToolbarBlank",
    attrs: {
      "href": "/attachments/createRefund/",
      "disabled": _vm.$engine.rights.rightIs('attachment_ajouter_order', false)
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "add"
    }
  })], 1), _vm._v(" "), _c('f7-fab', {
    staticClass: "leftfav2 button-fab bottomButton floatingButtonToolbarBlank",
    on: {
      "click": function($event) {
        return _vm.extractCSV()
      }
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "document_text"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "layoutTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "listPage"
  }, [_c('b-row', {
    staticClass: "form-group justify-content-start showLargeScreenOnly"
  }, [_c('b-col', {
    staticClass: "showLargeScreenOnly",
    attrs: {
      "sm": "2"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    attrs: {
      "href": "/attachments/import/",
      "disabled": _vm.$engine.rights.rightIs('attachment_import', false)
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "bullet_list"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.imprt')))])], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "showLargeScreenOnly",
    attrs: {
      "sm": "2"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    attrs: {
      "href": "/attachments/createInvoice/",
      "disabled": _vm.$engine.rights.rightIs('attachment_ajouter_facture', false)
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "add"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.generate')))])], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "2"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    on: {
      "click": function($event) {
        return _vm.extractCSV()
      }
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "document_text"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.extract')))])], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_c('f7-searchbar', {
    staticClass: "search filterTitle",
    attrs: {
      "search-list": "#attachment-list",
      "cancel-link": "Cancel",
      "placeholder": _vm.attachmentsPage_SearchAttachments,
      "clear-button": "",
      "virtual-init": ""
    },
    on: {
      "searchbar:search": _vm.onSearch,
      "searchbar:clear": _vm.onClear
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "itemList"
  }, [_c('div', {
    staticClass: "layoutSubtitle"
  }), _vm._v(" "), _c('attachments-list', {
    attrs: {
      "service": _vm.service,
      "Attachments": _vm.Attachments
    }
  }), _vm._v(" "), _c('pagination', {
    attrs: {
      "firstIndex": _vm.paginationObject.firstIndex,
      "maxResultsByPage": _vm.paginationObject.maxResults,
      "nbResultsTotal": _vm.paginationObject.nbResultsTotal,
      "refreshEvent": _vm.paginationObject.refresh
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "toolbarPageBottomBlank"
  })], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-492779c9", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-492779c9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/attachments/CMAttachmentsPage.vue
// module id = 2405
// module chunks = 2